import { graphqlApolloClient } from "../graphql-apollo-client"
import { CREATE_SUSTAINABILITY_DETAILS } from "./graphql/mutations/createSustainabilityDetails"

export const createSustainabilityDetails = async data => {
  const { data: responseData } = await graphqlApolloClient.mutate({
    mutation: CREATE_SUSTAINABILITY_DETAILS,
    variables: {
      data: data
    }
  })

  return responseData?.CreateSustainabilityDetails
}